import { PointerEvent } from 'react';

export const extendedClick = <T>(
  e: MouseEvent | PointerEvent | React.MouseEvent<HTMLDivElement, MouseEvent>,
  callback: (...args: T[]) => void
) => {
  if (
    e.ctrlKey ||
    e.shiftKey ||
    e.metaKey || // apple
    (e.button && e.button == 1) // middle click, >IE9 + everyone else
  ) {
    callback();
    return;
  }

  if (e.button === 2) return;

  callback();
};
